import * as React from 'react';
const EGDSSheetContext = React.createContext({
  maxHeight: undefined
});
export { EGDSSheetContext as default };